import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from "react";
import NumberFormat from "react-number-format";
import { Select, SelectField, TextField } from "..";
export var NON_FIELD_ERROR = "nonFieldError";

function groupErrorsByFields(errors) {
  return errors.reduce(function (o, error) {
    var key = error.field || NON_FIELD_ERROR;
    (o[key] = o[key] || []).push(error);
    return o;
  }, {});
}

function removeDuplicatedErrors(errors) {
  var keys = [];
  return errors.filter(function (error) {
    var key = error.message + error.field || "";
    var filter = !keys.includes(key);
    keys.push(key);
    return filter;
  });
}

var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);

  _createClass(Form, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var propsKey = (props.errors || []).map(function (error) {
        return error.field || NON_FIELD_ERROR;
      }).sort().join();
      var stateKey = (state.errors || []).map(function (error) {
        return error.field || NON_FIELD_ERROR;
      }).sort().join();

      if (propsKey !== stateKey) {
        var errors = removeDuplicatedErrors([].concat(_toConsumableArray(state.errors || []), _toConsumableArray(props.errors || [])));
        return {
          errors: errors
        };
      }

      return null;
    }
  }]);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    var errors = props.errors || [];
    var data = props.data || {};
    _this.state = {
      data: data,
      errors: errors
    };
    return _this;
  }

  _createClass(Form, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (JSON.stringify(prevProps.errors) !== JSON.stringify(this.props.errors)) {
        this.setState({
          errors: this.props.errors || []
        });
      }
    }
  }, {
    key: "renderWrappedChildren",
    value: function renderWrappedChildren(children) {
      var _this2 = this;

      // Traverse through all children
      return React.Children.map(children, function (child) {
        // This is support for non-node elements (eg. pure text), they have no props
        if (!child || !child.props) {
          return child;
        } // If current component has additional children, traverse through them as well


        if (child.props.children) {
          return React.cloneElement(child, {
            children: _this2.renderWrappedChildren(child.props.children)
          });
        }

        if (child.type === TextField || child.type === NumberFormat) {
          var defaultValue = _this2.state.data[child.props.name];
          var groupedErrors = groupErrorsByFields(_this2.state.errors);
          var errors = groupedErrors[child.props.name] || [];
          return React.cloneElement(child, {
            defaultValue: defaultValue,
            errors: errors,
            onBlur: function onBlur(event) {
              _this2.handleInputError(event);

              if (child.props.onBlur) {
                child.props.onBlur(event);
              }
            },
            onChange: function onChange(event) {
              _this2.handleFieldChange(event);

              _this2.handleInputError(event);

              if (child.props.onChange) {
                child.props.onChange(event);
              }
            },
            onInvalid: function onInvalid(event) {
              if (child.props.onInvalid) {
                child.props.onInvalid(event);
              }

              _this2.handleInputError(event);

              event.preventDefault();
            }
          });
        }

        if (child.type === SelectField || child.type === Select) {
          var _defaultValue;

          if (child.props.name === "country" && _this2.state.data[child.props.name]) {
            _defaultValue = {
              label: _this2.state.data[child.props.name].country,
              value: _this2.state.data[child.props.name].code
            };
          } else {
            _defaultValue = _this2.state.data[child.props.name];
          }

          return React.cloneElement(child, {
            defaultValue: _defaultValue,
            onChange: function onChange(value) {
              _this2.setState(function (state) {
                var data = _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, child.props.name, value));

                return {
                  data: data
                };
              });
            }
          });
        }

        if (child.props.type === "checkbox") {
          var _defaultValue2 = _this2.state.data[child.props.name] || false;

          return React.cloneElement(child, {
            defaultValue: _defaultValue2,
            onChange: function onChange() {
              _this2.setState(function (state) {
                var data = _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, child.props.name, !state.data[child.props.name]));

                return {
                  data: data
                };
              });
            }
          });
        }

        return child;
      });
    }
  }]);

  return Form;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.ref = React.createRef();

  this.handleSubmit = function (event) {
    var onSubmit = _this3.props.onSubmit;

    if (onSubmit !== undefined) {
      onSubmit(event, _this3.state.data);
    }
  };

  this.handleInputError = function (event) {
    var input = event.target;

    _this3.setState(function (state) {
      var errors = state.errors.filter(function (error) {
        return error.field !== input.name;
      });

      if (!input.validity.valid) {
        errors.push({
          message: input.validationMessage,
          field: input.name
        });
      }

      return {
        errors: errors
      };
    });
  };

  this.handleFieldChange = function (event) {
    var fieldName = event.target.name;
    var value = event.target.value;

    _this3.setState(function (state) {
      var data = _objectSpread(_objectSpread({}, state.data), {}, _defineProperty({}, fieldName, value));

      return {
        data: data
      };
    });
  };

  this.render = function () {
    var _this3$props = _this3.props,
        children = _this3$props.children,
        formRef = _this3$props.formRef,
        className = _this3$props.className,
        otherProps = _objectWithoutProperties(_this3$props, ["children", "formRef", "className"]);

    var errors = _this3.state.errors;
    var nonFieldErrors = groupErrorsByFields(errors)[NON_FIELD_ERROR];
    return React.createElement("form", _extends({
      ref: formRef
    }, otherProps, {
      onSubmit: _this3.handleSubmit,
      className: className
    }), nonFieldErrors ? React.createElement("span", {
      className: "form-error"
    }, nonFieldErrors.map(function (error) {
      return error.message;
    }).join(" ")) : null, _this3.renderWrappedChildren(children));
  };
};

export default Form;